module.exports = __webpack_public_path__ + "static/media/illu.7e75a51a.jpg";